var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialFacebook = function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12 22a10 10 0 0 1-7.065-2.933 9.98 9.98 0 0 1-2.934-7.053 9.45 9.45 0 0 1 .797-3.897A9.8 9.8 0 0 1 4.934 4.93a9.4 9.4 0 0 1 3.164-2.134A10 10 0 0 1 12 2a10 10 0 0 1 7.065 2.93 9.8 9.8 0 0 1 2.136 3.187A9.9 9.9 0 0 1 22 12.014a9.45 9.45 0 0 1-.797 3.897 9.4 9.4 0 0 1-2.136 3.158 10 10 0 0 1-3.163 2.134c-1.23.538-2.56.81-3.902.797m-2.592-9.645h1.482v4.496h1.851v-4.496h1.852v-1.849h-1.852v-.939a.65.65 0 0 1 .114-.395.34.34 0 0 1 .256-.171h1.482V7.174h-1.482a2.03 2.03 0 0 0-1.567.711 2.5 2.5 0 0 0-.655 1.707v.908H9.407z"
  })));
};
export default SvgSocialFacebook;